import axios from 'axios';
import { platformClientHeaders } from './platform-client-headers';
import { AbstractApiService, TokenProvider } from './abstractApiService';

class NoTokenProvider implements TokenProvider {
  public async currentToken(): Promise<string> {
    return '';
  }
}

export class PublicSharedApiService extends AbstractApiService {
  constructor(endpoint: string) {
    const tokenProvider = new NoTokenProvider();
    super(endpoint, tokenProvider);
  }

  private absoluteUrl(path: string): string {
    const endpoint = this.getEndpoint();
    const base = endpoint.endsWith('/') ? endpoint : `${endpoint}/`;
    return `${base}${path}`;
  }

  public async get<ResponseType>(options: {
    path: string;
    params?: Record<string, string | number | boolean | undefined>;
  }): Promise<ResponseType> {
    const { data } = await axios.get<ResponseType>(this.absoluteUrl(options.path), {
      headers: platformClientHeaders,
      params: options.params,
    });
    return data;
  }

  public async createGetWithoutResponseBody(options: { path: string }): Promise<void> {
    await axios.get(this.absoluteUrl(options.path), {
      headers: {
        ...platformClientHeaders,
        'Content-Type': 'application/json',
      },
    });
  }
}
